import React from "react";
import { Link } from "react-router-dom";

interface NetworkingCardsViewProps {
  title: string | React.ReactNode;
  children: React.ReactNode;

  isListLoading?: boolean;
  pageCount?: number;
  currentPage?: number;
  loadMore?: () => void;
}

type NetworkingCardsViewPropsWithConditionalProps =
  | (NetworkingCardsViewProps & {
      isListLoading: boolean;
      pageCount: number;
      currentPage: number;
      loadMore: () => void;
    })
  | (NetworkingCardsViewProps & {
      isListLoading?: never;
      pageCount?: never;
      currentPage?: never;
      loadMore?: never;
    });

export const NetworkingCardsView: React.FC<
  NetworkingCardsViewPropsWithConditionalProps
> = ({
  title,
  isListLoading,
  pageCount,
  currentPage,
  loadMore,
  children,
}): JSX.Element => {
  return (
    <div className="netw__group">
      <div className="netw__group-header">{title}</div>
      {children}
      {currentPage &&
        pageCount &&
        isListLoading !== undefined &&
        loadMore &&
        currentPage < pageCount && (
          <div className="netw__group-footer">
            <Link
              to="#"
              className="netw__more-items-btn"
              onClick={() => {
                if (!isListLoading) {
                  loadMore();
                }
              }}
            >
              <span>{isListLoading ? "Загружаем..." : "Показать ещё"}</span>
            </Link>
          </div>
        )}
    </div>
  );
};
